import { ref } from 'vue'

const isLoading = ref(false)
const loadingText = ref('Caricamento in corso...')

export function useLoader() {
  const showLoader = (text = 'Caricamento in corso...') => {
    loadingText.value = text
    isLoading.value = true
  }

  const hideLoader = () => {
    isLoading.value = false
  }
  const withLoader = async (asyncFunction, text = 'Caricamento in corso...') => {
    try {
      showLoader(text)
      const result = await asyncFunction()
      return result
    } catch (error) {
      // Gestisce silenziosamente gli errori di validazione
      // L'errore viene comunque propagato al chiamante ma senza logs aggiuntivi
      throw error
    } finally {
      hideLoader()
    }
  }

  const withLoaderSafe = async (asyncFunction, text = 'Caricamento in corso...', onError = null) => {
    try {
      showLoader(text)
      const result = await asyncFunction()
      return result
    } catch (error) {
      // Gestisce l'errore con callback personalizzato se fornito
      if (onError && typeof onError === 'function') {
        onError(error)
      }
      // Non ripropaga l'errore per evitare console errors
      return null
    } finally {
      hideLoader()
    }
  }

  const withInertiaLoader = async (inertiaForm, route, options = {}, text = 'Caricamento in corso...', method = 'post') => {
    return new Promise((resolve) => {
      showLoader(text)

      const originalOnSuccess = options.onSuccess
      const originalOnError = options.onError
      const originalOnFinish = options.onFinish

      inertiaForm[method](route, {
        ...options,
        onSuccess: (response) => {
          if (originalOnSuccess) originalOnSuccess(response)
          resolve({ success: true, response })
        },
        onError: (errors) => {
          if (originalOnError) originalOnError(errors)
          resolve({ success: false, errors })
        },
        onFinish: () => {
          hideLoader()
          if (originalOnFinish) originalOnFinish()
        }
      })
    })
  }

  return {
    isLoading,
    loadingText,
    showLoader,
    hideLoader,
    withLoader,
    withLoaderSafe,
    withInertiaLoader
  }
}
